export default {
    getInspections:{
        data:[],
        error:null,
        loading:false,
    },
    postInspections:{
        data:[],
        error:null,
        loading:false,
    },
    getVehicleStatus:{
        data:[],
        error:null,
        loading:false,
    },
    fetchVehiclePendingInspection:{
        data:[],
        error:null,
        loading:false,
    },
    addInspection:{
        data:[],
        error:null,
        loading:false,
    },
    getLicenseStatus:{
        data:[],
        error:null,
        loading:false,
    },
    getVehicleRoutes:{
        data:[],
        error:null,
        loading:false,
    },
    getVehicleRouteInspections:{
        data:[],
        error:null,
        loading:false,
    }
}